module.exports = __webpack_public_path__ + "static/media/call-bg.8679a351.jpg";